module.exports = __webpack_public_path__ + "img/simple-message.15ef68be.svg";